module.exports = __webpack_public_path__ + "img/img_display_mode_four.9eb78638.png";